import React from "react";

export default function ProfilePage() {
  return (
    <div className="aqx-main-inner">
      <div className="aqx-main-header">
        <h1>Profile</h1>
        <p>Operator profile placeholder. This page will manage user and operator-facing profile details.</p>
      </div>
    </div>
  );
}
